/** @jsx jsx */
/** @jsxFrag null */
import {jsx} from 'panel';

import {ModalType} from 'common/components/modal';
import {ModalEl} from 'common/components/modal/panel';
import {InputEl} from 'common/components/input/panel';
import {ButtonEl} from 'common/components/button/panel';
import type {NpsSurvey} from 'common/widgets/nps-survey/index';
import {ButtonTheme} from 'common/components/button/constants';

export function template(this: NpsSurvey) {
  const {open, responseText, score, submittedScore, surveyId} = this.state;

  return (
    <ModalEl
      sel='.nps-survey-root'
      class={{
        'nps-survey-score-screen': !submittedScore,
        'nps-survey-text-screen': submittedScore,
      }}
      attrs={{
        closeable: true,
        'modal-type': ModalType.Popup,
        'not-fullscreen': true,
        open,
      }}
      on={{change: this.helpers.handleModalChange}}
    >
      <div
        sel='.nps-survey-content'
        class={{
          'nps-survey-score-screen': !submittedScore,
          'nps-survey-text-screen': submittedScore,
        }}
      >
        {!submittedScore ? (
          <>
            <div sel='.nps-survey-header'>How likely are you to recommend Mixpanel to a friend or colleague?</div>
            <div sel='.nps-survey-scores'>
              {this.helpers.getScores().map((option) => (
                <div
                  sel='.nps-survey-score-button'
                  on={{
                    click: () => this.helpers.handleClickScore(option),
                  }}
                >
                  {option}
                </div>
              ))}
            </div>
            <div sel='.nps-survey-likeliness'>
              <span>Not at all likely</span>
              <span>Extremely likely</span>
            </div>
          </>
        ) : (
          <>
            <div sel='.nps-survey-header'>Thank you! Your feedback has been sent.</div>
            <div sel='.nps-survey-question'>
              <span sel='.nps-survey-text'>We read every single response. Why did you rate Mixpanel a {score}?</span>
            </div>
            <div sel='.nps-survey-response-text-container'>
              <InputEl
                sel='.nps-survey-response-text'
                type={`textarea`}
                autoFocus
                onInput={this.helpers.handleTextInput}
                value={responseText}
              />
            </div>
            <div sel='.nps-survey-button-container'>
              <ButtonEl sel='.nps-survey-dismiss-button' on={{click: this.helpers.handleClickDismiss}}>
                Dismiss
              </ButtonEl>
              <ButtonEl
                sel='.nps-survey-submit-button'
                attrs={{
                  theme: ButtonTheme.Primary,
                  disabled: !Number.isInteger(surveyId),
                }}
                on={{click: this.helpers.handleClickSubmit}}
              >
                Submit
              </ButtonEl>
            </div>
          </>
        )}
      </div>
    </ModalEl>
  );
}
